export default __webpack_public_path__ + "static/media/Phone.33abb573.svg";